import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetConfigurationCode, resetError } from '../../../../Reducers/Configurator/Actions';
import { withStyles } from '@material-ui/core/styles';
import { setVisible } from '../../../../Reducers/Ui/Actions';

import pdfIcon from './icons/pdf.svg';

const PdfButton = withStyles({
  root: {
    display: 'flex',
    cursor: 'pointer',
    flexDirection: 'row',
    alignItems: 'center',
    margin: '0 8px',
  },
  icon: {
    width: 32,
  },
  label: {
    fontSize: '0.9em',
  },
})(({ classes }) => {
  const { error } = useSelector((state) => state.ui);
  const dispatch = useDispatch();

  const handlePdf = async () => {
    if (error) {
      dispatch(resetError());
    }
    await dispatch(resetConfigurationCode());
    await dispatch(setVisible('pdfDownload', true));
  };

  return (
    <div className={classes.root} onClick={handlePdf}>
      <img src={pdfIcon} className={classes.icon} />
    </div>
  );
});

export default PdfButton;
